export default "__VITE_ASSET__441e177e__"